<template>
  <div class="element-phone">
    <Input :placeholder="placeholder||''" v-model="currentValue" readonly></Input>
    <a class="oper-link" v-if="!readonly" @click="showUpdateModal">更换手机号</a>

    <Modal v-model="updatePhone.modalFlag" title="更换手机号">
      <div class="">
        <Form :model="updatePhone" label-position="left" :label-width="100">
          <FormItem label="手机号：">
            <Input v-model="updatePhone.phone" placeholder="请输入新的手机号"></Input>
          </FormItem>
          <FormItem label="验证码：">
            <Input v-model="updatePhone.code" placeholder="输入验证码" class="send-message">
              <span slot="append" :class="{'disabled': (!formItemRules.isPHONE.test(updatePhone.phone)||updatePhone.sending)}" @click="getMessageCode">{{updatePhone.sending?updatePhone.countDown+'秒':'发送'}}</span>
            </Input>
          </FormItem>
        </Form>
      </div>
      <div slot="footer">
        <Button type="primary" size="large" @click="savePhone">保存</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
// 当前用户修改个人手机号码组件
export default {
  name: 'phone',
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    readonly: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'text'
    },
    placeholder: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      currentValue: '',
      formItemRules: {},
      timer: null,
      updatePhone: {
        phone: '',
        code: '',
        sending: false,
        countDown: 60,
        modalFlag: false
      }
    }
  },
  created () {
    /* global FormItemRules:true */
    this.currentValue = this.value;
    this.formItemRules = FormItemRules;
  },
  watch: {
    value: function (val) {
      this.currentValue = val;
    }
  },
  methods: {
    change () {
      this.$emit('input', this.currentValue);
      this.$emit('on-change');
    },
    inputBlur () {
      this.$emit('on-blur');
    },
    getMessageCode () {
      const _self = this;
      if (!_self.formItemRules.isPHONE.test(_self.updatePhone.phone)) {
        _self.$Message.warning('请输入有效的电话号码');
      } else if (!_self.updatePhone.sending) {
        _self.updatePhone.sending = true;
        _self.updatePhone.countDown = 60;

        _self.timer = setInterval(function () {
          _self.updatePhone.countDown = --_self.updatePhone.countDown;
          if (_self.updatePhone.countDown <= 0) {
            clearInterval(_self.timer);
            _self.updatePhone.sending = false;
          }
        }, 1000);

        _self.fetch('/transformPhoneSend', {mobile: _self.updatePhone.phone}).then(res => {
          _self.$Message.success('发送成功');
        }).catch(() => {
          // _self.$Message.error('验证码发送失败，请重新操作');
          // 发送短信请求失败，则初始化让用户重新发送
          if (_self.timer) {
            clearInterval(_self.timer);
          }
          _self.updatePhone.sending = false;
        });
      } else {
        _self.$Message.info(`短信已发送，请输入验证码，或再${_self.updatePhone.countDown}秒后重试`);
      }
    },
    showUpdateModal () {
      this.updatePhone.modalFlag = true;
    },
    savePhone () {
      const _self = this;
      _self.post('/transformPhone', {mobile: _self.updatePhone.phone, smsCode: _self.updatePhone.code}).then(res => {
        _self.$Message.success('手机号修改成功！');
        _self.currentValue = _self.updatePhone.phone;
        _self.change();

        _self.updatePhone.modalFlag = false;
      });
    }
  }
}
</script>

<style lang="less" scoped>
  .element-phone {
    .oper-link {
      bottom: 0;
      position: absolute;
      right: 6px;
      z-index: 1;
    }
  }
  .send-message {
    .kh-input{
      border-right: 0 none;
    }
    .kh-input-group-append {
      background-color: transparent;
      border-left: 0 none;
      line-height: 38px;
      padding: 0;
      width: 75px;
      span {
        cursor: pointer;
        display: block;
        width: 60px;
        &:hover {
          color: @base-color;
        }
        &.disabled {
          color: @input-disabled-color;
          background-color: @input-disabled-bg;
          &:hover {
            color: @input-disabled-color;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/defined/phone.vue